import React, {useMemo} from "react";
import {Tooltip} from "@mui/material";

const LargeThemeColor = ({themes, selectedThemeId, name}) => {
    const color = useMemo(() => (
        themes?.find(e => e.id === selectedThemeId)?.values?.find(e => e.colorName === name)?.value
    ), [themes, selectedThemeId, name])


    return (
        <>
            <Tooltip followCursor title={`Primary Color ${color}`}>
                <div
                    className={'theme-primary-color'}
                    style={{'--theme-primary-color': color,}}
                />
            </Tooltip>
        </>
    );
}

export default LargeThemeColor;
